// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".font-xs[data-v-134168d7]{font-size:.75rem}.btn-link[data-v-134168d7]{border-style:none!important;background:transparent;padding:0}", ""]);
// Exports
module.exports = exports;
